module.exports = __webpack_public_path__ + "img/scorecard-example.7ab514f6.jpg";